const setObjective = (val = null) => {
  return {
    type: 'SET_OBJECTIVE',
    data: val,
  }
}

export default {
  setObjective,
}
